module.exports = __webpack_public_path__ + "static/img/8.3a68eff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/sp/8.png
// module id = +8lK
// module chunks = 0